import { Page } from 'components/layout';
import { Box, DesktopOnly, Loading, Message, MobileOnly } from 'components/ui';
import { REQUEST_STATUS } from '../../constants';
import { futuraChainId } from 'utils/config';
import RemixStudio from 'components/RemixStudio';
import ConnectedWalletGuard from 'components/ConnectedWalletGuard';
import { useWallet } from 'components/WalletContext';
import { useOwnedFuturaNfts } from 'hooks/useFutura';

const RemixPage = () => {
  const { address, network } = useWallet();
  const { mix, status, ownsMixpass } = useOwnedFuturaNfts(address);

  const isLoading = status === REQUEST_STATUS.loading;
  const isError = status === REQUEST_STATUS.error;

  return (
    <Page
      title="Futura Remix Studio"
      background="#333"
      p={0}
      fixedFooter={!address || isLoading || isError || network !== futuraChainId}
      showHeader
      showFooter
    >
      <DesktopOnly>
        <ConnectedWalletGuard networkId={futuraChainId}>
          {isLoading && (
            <Box width="100%" textAlign="center">
              <Loading />
            </Box>
          )}
          {isError && <Message color="black">Error loading items.</Message>}
          {status === REQUEST_STATUS.success && (
            <RemixStudio mixes={mix} ownsMixpass={ownsMixpass} />
          )}
        </ConnectedWalletGuard>
      </DesktopOnly>
      <MobileOnly>
        <Message color="black">Remix Studio is not available on mobile devices.</Message>
      </MobileOnly>
    </Page>
  );
};

export default RemixPage;
